import * as is from 'is_js';

export const getElementTop = (element: HTMLElement): number => {
  if (element) {
    const box = element.getBoundingClientRect();
    const body = document.body;
    const docEl = document.documentElement;
    const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    const clientTop = docEl.clientTop || body.clientTop || 0;
    return box.top + scrollTop - clientTop;
  }
  return 0;
};

export const scrollToElement = (element: HTMLElement, offSet = 0): void => {
  const scrollTo = getElementTop(element) - offSet;
  if (is.ie() === true || is.edge() === true) {
    window.scroll(0, scrollTo);
  } else {
    window.scroll({ top: scrollTo, left: 0, behavior: 'smooth' });
  }
};

export const removeTags = (str: string): string => {
  if (!str) {
    return '';
  }
  return str.replace(/(<([^>]+)>)/gi, '');
};

export const isNotNumber = (input: string): boolean => {
  const num = parseFloat(input);
  return isNaN(num);
};

export const altElementSelector = (primarySelector: string, secondarySelector?: string): Promise<HTMLElement> => {
  return new Promise((resolve, reject) => {
    const observer = new MutationObserver((_) => {
      if (document.querySelector(primarySelector)) {
        resolve(document.querySelector(primarySelector) as HTMLElement);
      } else if (secondarySelector) {
        resolve(document.querySelector(secondarySelector) as HTMLElement);
      } else {
        reject('Neither element can be found');
      }
      observer.disconnect();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
};
